export default __webpack_public_path__ + "static/media/whitelist.58d6da79.png";